import * as fromDatatype from '../datatype-library/index';

export interface app_login_registration_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    registration_type: fromDatatype.VarcharDatatypeInterface;
    login_method: fromDatatype.VarcharDatatypeInterface;
    registration_key: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    subject_guid: fromDatatype.VarcharDatatypeInterface;
    category: fromDatatype.VarcharDatatypeInterface;
    registration_status: fromDatatype.VarcharDatatypeInterface;
    verification_code: fromDatatype.VarcharDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface;
    temporary_password: fromDatatype.VarcharDatatypeInterface;
    expiry_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    post_registration_json: fromDatatype.JsonDatatypeInterface;
    invited_by: fromDatatype.VarcharDatatypeInterface;
    invite_date: fromDatatype.TimestampTzDatatypeInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_login_registration_RowClass implements app_login_registration_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    registration_type: fromDatatype.VarcharDatatypeInterface;
    login_method: fromDatatype.VarcharDatatypeInterface;
    registration_key: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    subject_guid: fromDatatype.VarcharDatatypeInterface;
    category: fromDatatype.VarcharDatatypeInterface;
    registration_status: fromDatatype.VarcharDatatypeInterface;
    verification_code: fromDatatype.VarcharDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface;
    temporary_password: fromDatatype.VarcharDatatypeInterface;
    expiry_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    post_registration_json: fromDatatype.JsonDatatypeInterface;
    invited_by: fromDatatype.VarcharDatatypeInterface;
    invite_date: fromDatatype.TimestampTzDatatypeInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}